import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DBFirestoreService } from '../dbfirestore.service';
import { FS_Giorno, FS_Ordine } from '../def/fs_tables';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-odl-stats',
    templateUrl: './odl-stats.component.html',
    styleUrls: ['./odl-stats.component.scss']
})
export class OdlStatsComponent implements OnInit, OnDestroy {

    rawdata = [];

    selectedYear: number;
    report_data: any = {};
    show_report = 'generale';

    loading = false;

    private unsubscribe$ = new Subject<void>();

    constructor(
        private route: ActivatedRoute,
        private api: DBFirestoreService,
    ) { }


    ngOnInit() {
        this.route.params
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(p => {
            this.selectedYear = parseInt(p.year, 0);
            this.getReportData();
        });
    }

    onFilterChange(filter) {
        this.filterReportData(filter);
        this.show_report = filter.report_type;
    }

    getReportData() {
        // this.report_data = this.dummydata;
        const from = new Date();
        const to = new Date();
        from.setDate(1); // Temporaneamente impostiamo un giorno valido per qualunque mese/anno
        from.setFullYear(this.selectedYear);
        from.setMonth(0);        
        from.setDate(1);
        from.setHours(0);
        from.setMinutes(0);
        from.setSeconds(0);

        to.setDate(1); // Temporaneamente impostiamo un giorno valido per qualunque mese/anno
        to.setFullYear(this.selectedYear);
        to.setMonth(11); 
        to.setDate(31);
        to.setHours(23);
        to.setMinutes(59);
        to.setSeconds(59);

        this.loading = true;


        const subscription = this.api.collectionFSGiorni(from, to)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(data => {
            this.rawdata = data;
            const report_data = {
                interventi: {},
                clienti: {},
                generale: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            };
            this.rawdata.forEach((giorno: FS_Giorno) => {
                const tipoIntervento = this.mapIntervento(giorno.tipo_intervento);
                const tipoCliente = this.mapCliente(giorno.tipo_cliente ? giorno.tipo_cliente : '');
                const mese = giorno.giorno_ora.toDate().getMonth();
                if (report_data.interventi[tipoIntervento] === undefined) {
                    report_data.interventi[tipoIntervento] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
                }
                if (report_data.clienti[tipoCliente] === undefined) {
                    report_data.clienti[tipoCliente] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
                }
                report_data.interventi[tipoIntervento][mese]++;
                report_data.clienti[tipoCliente][mese]++;

                report_data.generale[mese]++;
            })

            this.loading = false;
            this.report_data = report_data;            

        })

    }

    filterReportData(filter) {

        const report_data = {
            interventi: {},
            clienti: {},
            generale: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        };

        this.rawdata.forEach((giorno: FS_Giorno) => {
            const tipoIntervento = this.mapIntervento(giorno.tipo_intervento);
            const tipoCliente = this.mapCliente(giorno.tipo_cliente ? giorno.tipo_cliente : '');

            if (filter.tipo_intervento && filter.tipo_intervento !== tipoIntervento) {
                return;
            }
            if (filter.tipo_cliente && filter.tipo_cliente !== tipoCliente) {
                return;
            }

            const mese = giorno.giorno_ora.toDate().getMonth();

            if (report_data.interventi[tipoIntervento] === undefined) {
                report_data.interventi[tipoIntervento] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
            }
            if (report_data.clienti[tipoCliente] === undefined) {
                report_data.clienti[tipoCliente] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
            }
            report_data.interventi[tipoIntervento][mese]++;
            report_data.clienti[tipoCliente][mese]++;
            report_data.generale[mese]++;
        })

        this.report_data = report_data;

    }

    mapIntervento(id: string): string {
        switch (id) {
            case '3YdS3IBXFTHcLQs7LjqB':
                return 'trasporti'; break;
            case 'E2xWE73OFcCDA5bzr6kZ':
                return 'disinfestazioni'; break;
            case 'ITOJyI6KMPqU696GNYIL':
                return 'bonifica_serbatoi'; break;
            case 'J2v2jdOd4kgOOLhek4Tx':
                return 'bonifica_siti'; break;
            case 'OHgrfsX5MD5fzmVsj1e8':
                return 'prove_tenuta'; break;
            case 'QvNpNRNKlwcGqn90GLA8':
                return 'lavaggi_disoleatori'; break;
            case 'ZXweEbAWooM8WmBOPz2b':
                return 'spurgo_vasche'; break;
            case 'gosXRyEFMq8OfGI5iXHj':
                return 'pulizia_pdu'; break;
            case 'rffoHZBk9qPtNtlzqBNH':
                return 'altro'; break;
            case 'slsEc3GFAmcf7aBEuAgV':
                return 'eternit'; break;
        }
        return 'unknown';
    }

    mapCliente(id: string): string {
        switch (id) {
            case '44mIWxEpQx6nijn9YcNJ':
                return 'clienti_fuori_categoria'; break;
            case '6A3ZFBg4K0ffFm7jC8zG':
                return 'hotel'; break;
            case 'AVCdaHC4fNwfXs9cfLqL':
                return 'ditte'; break;
            case 'TWG3NRMsdgPy8lT0llCY':
                return 'pubblica_amministrazione'; break;
            case 'eBF2DJGBrZmjpDs8eWTr':
                return 'clienti_privati'; break;
            case 'qk2oM2HnO3UazEQLljI3':
                return 'condomini'; break;
        }
        return 'unknown';
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
